import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { privateFetch } from '../../../../utils/apiHelper';
import { confirmDialog } from 'primereact/confirmdialog';

import styles from '../../../../components/Display/Wrapper.module.scss';
import MemberPanel from './MemberPanel';
import MemberItem from './MemberItem';

function MemberPage({ isActive }) {
  const { accountContext } = useAccountContext();
  const [memberList, setMemberList] = useState([]);
  const [memberDetail, setMemberDetail] = useState(undefined);
  const [panelIsOpen, setPanelIsOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [layout, setLayout] = useState('grid');

  useEffect(() => {
    fetchMemberList();
  }, []);

  const fetchMemberList = async () => {
    await privateFetch('GET', 'rab', `/cu/${accountContext.id}/member/`).then((res) => {
      setMemberList(res);
    });
  };

  const handleOpenManager = () => {
    setPanelIsOpen(true);
  };

  const createMember = async (memberForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'rab',
      `/cu/${accountContext.id}/member/`,
      "L'adhérent a bien été ajouté",
      JSON.stringify(memberForm)
    ).then(() => {
      fetchMemberList();
      setPanelIsOpen(false);
      setLoading(false);
    });
  };

  const updateMember = async (memberForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'rab',
      `/cu/${accountContext.id}/member/${memberDetail.id}/`,
      "L'adhérent a bien été modifié",
      JSON.stringify(memberForm)
    ).then(() => {
      fetchMemberList();
      setPanelIsOpen(false);
      setLoading(false);
    });
  };

  const deleteMember = async (member) => {
    await privateFetch(
      'DELETE',
      'rab',
      `/cu/${accountContext.id}/member/${member.id}/`,
      "L'adhérent a bien été supprimé"
    ).then(() => {
      fetchMemberList();
    });
  };

  const toggleLayout = () => {
    setLayout(layout === 'grid' ? 'list' : 'grid');
  };

  const changeLayoutAction = {
    onClick: toggleLayout,
    ariaLabel: "changer le mode d'affichage",
    icon: layout === 'grid' ? 'pi-list' : 'pi-th-large'
  };

  const newMemberAction = {
    onClick: handleOpenManager,
    label: 'Ajouter un adhérent',
    icon: 'pi-plus'
  };

  const confirmMemberDeletion = (member) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer cette adhérent ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => deleteMember(member)
    });
  };

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper label="Adhérents" actions={[changeLayoutAction, newMemberAction]}>
        <div className={styles.pageContentContainer}>
          <div className={` ${layout === 'grid' ? styles.gridLayout : styles.listLayout}`}>
            {memberList.map((member, index) => (
              <MemberItem
                layout={layout}
                key={index}
                member={member}
                handleClickMember={() => {
                  setMemberDetail(member);
                  setPanelIsOpen(true);
                }}
                confirmMemberDeletion={() => confirmMemberDeletion(member)}
              />
            ))}
          </div>
        </div>
      </PageWrapper>

      <MemberPanel
        isOpen={panelIsOpen}
        loading={loading}
        member={memberDetail}
        onUpdate={updateMember}
        onClose={() => {
          setPanelIsOpen(false);
          setMemberDetail(undefined);
        }}
        onCreate={createMember}
      />
    </div>
  );
}

export default MemberPage;
